import React from 'react';
import { Checkbox, Row, Tag, Tooltip } from 'antd';
import { generateOperator, NULL_VALUE } from './utils';
import { useGetFieldsChange } from 'pages/reporting/hook/useGetFieldsChange';
import { APL_KEY, useGetAPLGrid } from 'hooks/apl/useGetAPLGrid';

const PropertyAdvancedFilter = ({ property }) => {
  return (
    <Row>
      {property?.isParent ? (
        <div style={{ width: '100%', display: 'flex' }}>
          <Tag style={{ margin: 2 }} color='blue'>
            {property?.operation} - Group conditions
          </Tag>
          {property?.strictMode && (
            <Checkbox
              style={{ marginLeft: 'auto' }}
              checked={property?.strictMode}
            >
              Nested Mode
            </Checkbox>
          )}
        </div>
      ) : (
        <Tooltip
          overlayClassName='scroller'
          overlayStyle={{ maxHeight: '50vh' }}
          title={<RenderValue property={property} />}
        >
          <Tag
            style={{
              margin: 2,
              maxWidth: 300,
              overflowX: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            <RenderValue property={property} />
          </Tag>
        </Tooltip>
      )}
    </Row>
  );
};

const RenderValue = ({ property }) => {
  const { operator, value, values, otherValue, displayName, dataType } =
    property ?? {};
  const { getPropertyData } = useGetFieldsChange();

  const isAplProperty = displayName === 'Search Set';

  const { data } = useGetAPLGrid({
    key: APL_KEY.getAplGrid('reporting'),
    params: {
      pageSize: 9999,
      pageIndex: 1,
    },
    enabled: isAplProperty,
  });

  const valueFieldPath =
    displayName === 'Field Path' ? getPropertyData(value) : '';

  const genOperator = generateOperator(operator);
  const hasValue =
    value || values?.length > 0 || dataType === 'boolean' || value === 0;

  const renderValue = (() => {
    if (!hasValue) return 'Empty value';

    if (isAplProperty) {
      const { gridData } = data || {};
      const apl = gridData?.find(({ id }) => value === id);

      return apl?.aplName || value;
    }

    if (valueFieldPath?.fullPathDisplayName)
      return valueFieldPath?.fullPathDisplayName;

    if (values?.length > 0) return values?.join(', ');

    if (value || value === 0) return `${value}`;

    return `${false}`;
  })();

  return (
    <>
      {displayName}
      {genOperator ? (
        <span style={{ margin: '0px 4px', fontWeight: 700 }}>
          {genOperator}
        </span>
      ) : null}
      {!NULL_VALUE.includes(operator) && (
        <>
          <span>{renderValue}</span>
          {hasValue && otherValue ? ' and ' : null}
          <span>{otherValue ? `${otherValue}` : null}</span>
        </>
      )}
    </>
  );
};

export default PropertyAdvancedFilter;
